import { useState, useCallback } from 'react';
import { j201Api, FJ110 } from '../../../services/j201Api';

export function useJ201LookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  /** Batch-resolve all lookup names for master fields */
  const resolveAllNames = useCallback(async (data: Partial<FJ110>) => {
    const entries: [string, string, string][] = [
      ['customer', 'customer', data.fj110_12 || ''],
      ['currency', 'currency', data.fj110_14 || ''],
      ['salesperson', 'employee', data.fj110_21 || ''],
      ['department', 'department', data.fj110_22 || ''],
      ['entryPerson', 'employee', data.fj110_91 || ''],
      ['remarkTemplate', 'remarkTemplate', data.fj110_30 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        j201Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  /** Resolve a single lookup name (for onBlur events) */
  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await j201Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  /** Clear all cached names */
  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
